import gql from 'graphql-tag';

export const ADMIN_UPDATE_DASHBOARD_ACCESS_BY_ACCOUNT = gql`
  mutation UpdateDashboardAccessByAccount($input: UpdateDashboardAccessByAccount!) {
    externalDashboards {
      result: adminUpdateDashboardAccessByAccount(input: $input) {
        error
        success
      }
    }
  }
`;
